import axios from 'axios'
import { useKeycloak } from '@josempgon/vue-keycloak'

// Create an instance of axios with the base URL read from the environment
const instance = axios.create({ baseURL: import.meta.env.VITE_CLOUDSERVICE_URL })
const { token, keycloak } = useKeycloak()

// Request interceptor for API calls
instance.interceptors.request.use(async config => {
    try {
        await keycloak.value?.updateToken(10)
        if (token.value)
            config.headers.Authorization = `Bearer ${token.value}`
        return config
    } catch (error) {
        console.error('Token refresh failed', error)
        keycloak.value?.login();
        return Promise.reject(error)
    }
},
    error => {
        return Promise.reject(error)
    },
)
const httpClient = {
    client: instance
}

export default httpClient;